




























import { Component, Vue, Prop } from "vue-property-decorator";
import { FileEntryModel } from "../models/fileEntry";
import dateFlip from "shared/filters/dateflip";

@Component({
  filters: { dateFlip },
})
export default class FileList extends Vue {
  @Prop({ required: true, type: Array }) value!: FileEntryModel[];
  @Prop({ required: false, type: Boolean, default: false }) tooltip!: boolean;
  @Prop({ required: true, type: String }) projectType!: string;

  private headers = [
    { text: this.t("category"), value: "category" },
    { text: this.t("description"), value: "description" },
    { text: this.t("archive_date"), value: "archive_date" },
    { text: "", value: "", sortable: false },
  ];

  private pagination = {
    descending: true,
    sortBy: "archive_date",
  };

  private t(key: string): string {
    return this.$t("houseprojects.tables.files." + key).toString();
  }

  private mounted() {
    (this.$refs.fileListTooltip as Element).parentElement!.className =
      "tooltip-container";
  }
}
